<template>
	<b-container>
		<b-row align-h="center">
			<b-col cols="10">
				<div v-animate-onscroll="'animate__animated animate__bounceIn'">
					<LogoFooter />
				</div>
				<p class="copyright mb-0">OnFocus Media S.L. &copy; 2015-{{ nowYear }}</p>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import LogoFooter from '@/components/LogoFooter.vue'

export default {
	name: 'Footer',

	components: {
		LogoFooter
	},

	computed: {
		nowYear() {
			const now = new Date(Date.now())

			return now.getFullYear()
		}
	}
}
</script>

<style lang="scss">
@import '@/assets/scss/_component-footer.scss';
</style>
